/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ConsentType = (typeof ConsentType)[keyof typeof ConsentType];

export const ConsentType = {
  telehealth_informed_consent: "telehealth_informed_consent",
  terms_of_use_and_privacy: "terms_of_use_and_privacy",
  data_sharing: "data_sharing",
  surescripts_consent: "surescripts_consent",
  surescripts_recorded_consent: "surescripts_recorded_consent",
  sms_consent_to_treat: "sms_consent_to_treat",
  hie_consent: "hie_consent",
  bridge_insurance_consent: "bridge_insurance_consent",
  cms_access_consent: "cms_access_consent",
} as const;
